import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    addDomains,
    changeDomainType,
    removeDomains
} from '../../../common/actions/domain-management-action-creators';
import { closeRightPane } from '../../../common/actions/right-pane-action-creators';

import {
    allFormattedDomainErrorsSelector,
    domainActionTypeSelector
} from './manage-in-bulk-selectors';
import { manageBulkIsLoadingSelector } from '../../../common/selectors/domain-management-selectors';
import { rightPaneAttributesSelector } from '../../../common/selectors/right-pane-selectors';

import DomainManagementBulk from './domain-management-bulk';

export const DomainManagementBulkContainer = ( {
    addDomains,
    changeDomainType,
    closeRightPane,
    domainActionType,
    domainErrors,
    manageBulkIsLoading,
    removeDomains
} ) => {
    return (
        <DomainManagementBulk
            addDomains={addDomains}
            changeDomainType={changeDomainType}
            closeRightPane={closeRightPane}
            domainActionType={domainActionType}
            domainErrors={domainErrors}
            isLoading={manageBulkIsLoading}
            removeDomains={removeDomains}
        />
    );
};

/* istanbul ignore next */
const mapStateToProps = ( state ) => (
    {
        domainActionType: domainActionTypeSelector( state ),
        domainErrors: allFormattedDomainErrorsSelector( state ),
        manageBulkIsLoading: manageBulkIsLoadingSelector( state ),
        rightPaneAttributes: rightPaneAttributesSelector( state ),
    }
);

DomainManagementBulkContainer.propTypes = {
    addDomains: PropTypes.func.isRequired,
    changeDomainType: PropTypes.func.isRequired,
    closeRightPane: PropTypes.func.isRequired,
    domainActionType: PropTypes.string,
    domainErrors: PropTypes.object,
    manageBulkErrorMessage: PropTypes.string,
    manageBulkIsLoading: PropTypes.bool.isRequired,
    removeDomains: PropTypes.func.isRequired,
};

export default connect(
    mapStateToProps,
    {
        addDomains,
        changeDomainType,
        closeRightPane,
        removeDomains
    }
)( DomainManagementBulkContainer );
